// JobAllRequest.jsx
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";

import JobCard from "../JobFlow/JobAllRequests/JobCard";
import SideNavigationBar from "../../reusables/SideNavigationBar/SideNavigationBar";
import { useRecruiterRequests } from "../../../hooks/recruiter/useRecruiterRequests";
import RecruiterRequestCard from "../JobFlow/JobAllRequests/RecruiterRequestCard";
import { Color } from "../../../GlobalStyles";
import { InfoOutlined } from "@mui/icons-material";

function RecruiterRequests() {
  // State to track active filters
  const [activeFilter, setActiveFilter] = useState(null);


  const {data: recruiterRequests, isLoading: initialLoading, fetchNextPage: fetchMore, hasNextPage: hasMore, isFetchingNextPage: loading, error} = useRecruiterRequests(activeFilter);
  console.log("recruiterRequests:", recruiterRequests);

  const allRecruiterRequests = recruiterRequests?.pages.flatMap(page => page.data) || [];

  const observer = useRef();
  const lastRecruiterRequestElementRef = useCallback(
    (node) => {
      if (initialLoading || loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            fetchMore();
          }
        },
        { threshold: 0.5 }
      );

      if (node) observer.current.observe(node);
    },
    [initialLoading, loading, hasMore, fetchMore]
  );

  // Handle status filter buttons
  const handleStatusFilter = (status) => {
    setActiveFilter(prev => prev === status ? null : status);
  };

  // if (initialLoading) {
  //   return <div className="p-6">Loading</div>;
  // }

  if (error) {
    return <div className="p-6">Error: {error.message}</div>;
  }

  // if (!allRecruiterRequests || allRecruiterRequests.length === 0) {
  //   return <div className="p-6">No Recruiter Requests For now</div>;
  // }

  return (
    <Box sx={{ ml: 10 }}>
      <SideNavigationBar />
      
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"  ,py: 1,px: 3}}>
          <Typography  sx={{ fontSize: "40px", whiteSpace: "nowrap" }}>
            All Recruiter Requests
          </Typography>
            <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center", gap: "4px", width: "100%" }}>
                <Button
                variant={activeFilter === "pending" ? "contained" : "outlined"}
                onClick={() => handleStatusFilter("pending")}
                sx={{
                    bgcolor: activeFilter === "pending" ? Color.primary3 : "transparent",
                    color: activeFilter === "pending" ? "#fff" : Color.primary3,
                    borderRadius: "20px",
                    px: 3,
                    py: 1,
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: 500,
                    border: `1px solid ${Color.primary3}`,
                    "&:hover": {
                    bgcolor: activeFilter === "pending" ? Color.primary3 : "rgba(0, 0, 0, 0.04)",
                    },
                }}
                >
                Pending
                </Button>
                <Button
                variant={activeFilter === "approved" ? "contained" : "outlined"}
                onClick={() => handleStatusFilter("approved")}
                sx={{
                    bgcolor: activeFilter === "approved" ? Color.primary3 : "transparent",
                    color: activeFilter === "approved" ? "#fff" : Color.primary3,
                    borderRadius: "20px",
                    px: 3,
                    py: 1,
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: 500,
                    border: `1px solid ${Color.primary3}`,
                    "&:hover": {
                    bgcolor: activeFilter === "approved" ? Color.primary3 : "rgba(0, 0, 0, 0.04)",
                    },
                }}
                >
                Approved
                </Button>
                <Button
                variant={activeFilter === "rejected" ? "contained" : "outlined"}
                onClick={() => handleStatusFilter("rejected")}
                sx={{
                    bgcolor: activeFilter === "rejected" ? Color.primary3 : "transparent",
                    color: activeFilter === "rejected" ? "#fff" : Color.primary3,
                    borderRadius: "20px",
                    px: 3,
                    py: 1,
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: 500,
                    border: `1px solid ${Color.primary3}`,
                    "&:hover": {
                    bgcolor: activeFilter === "rejected" ? Color.primary3 : "rgba(0, 0, 0, 0.04)",
                    },
                }}
                >
                Rejected
                </Button>
            </Box>
          </Box>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {allRecruiterRequests.map((recruiterRequest, index) => {
          if (allRecruiterRequests.length === index + 1) {
            return (
              <div ref={lastRecruiterRequestElementRef} key={recruiterRequest.id}>
                <RecruiterRequestCard request={recruiterRequest} />
              </div>
            );
          } else {
            return (
              <div key={recruiterRequest.id}>
                <RecruiterRequestCard request={recruiterRequest} />
              </div>
            );
          }
        })}
      </div>

      {(loading || initialLoading) && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[...Array(5)].map((_, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                p: 2,
                m: 2,
                borderRadius: 2,
                backgroundColor: "#fff",
                boxShadow: 1,
              }}
            >
              <Box sx={{ flex: 1, height: "20px", backgroundColor: "#f0f0f0", borderRadius: 1, mr: 2 }} />
              <Box sx={{ flex: 1, height: "20px", backgroundColor: "#f0f0f0", borderRadius: 1, mr: 2 }} />
              <Box sx={{ flex: 2, height: "20px", backgroundColor: "#f0f0f0", borderRadius: 1, mr: 2 }} />
              <Box sx={{ flex: 1, height: "20px", backgroundColor: "#f0f0f0", borderRadius: 1, mr: 2 }} />
              <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                <Box sx={{ width: "60px", height: "36px", backgroundColor: "#f0f0f0", borderRadius: 2 }} />
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {allRecruiterRequests.length === 0 && (
        <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%",marginTop: 10}}>
          <Typography sx={{fontSize: 24, color: "#666"}}>
          No {activeFilter ? `${activeFilter.charAt(0).toUpperCase() + activeFilter.slice(1)}` : ""} Recruiter Requests Found 
          </Typography>
        </Box>
      )}

      {!hasMore && allRecruiterRequests.length > 0 && (
        <div className="mt-6 text-center py-4 text-gray-500 border-t">
          {/* {activeFilters.length > 0 ? `No more recruiter requests with status: ${activeFilters.join(", ")}` : "No more recruiter requests to load"} */}
        </div>
      )}
    </Box>
  );
}

export default RecruiterRequests;
